import { css } from 'styled-components';
import { responsiveProperty } from './responsiveProperty';
export const paddingPropsNames = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py'];
export const paddingProps = css `
  ${(props) => props.p && responsiveProperty('padding', props.p)};
  ${(props) => props.pt && responsiveProperty('paddingTop', props.pt)};
  ${(props) => props.pr && responsiveProperty('paddingRight', props.pr)};
  ${(props) => props.pb && responsiveProperty('paddingBottom', props.pb)};
  ${(props) => props.pl && responsiveProperty('paddingLeft', props.pl)};

  ${(props) => props.px && responsiveProperty('paddingLeft', props.px)};
  ${(props) => props.px && responsiveProperty('paddingRight', props.px)};

  ${(props) => props.py && responsiveProperty('paddingTop', props.py)};
  ${(props) => props.py && responsiveProperty('paddingBottom', props.py)};
`;
